/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCircleSquareFill: {
  name: 'circle-square-fill';
  data: string;
} = {
  name: 'circle-square-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 .5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm5 8A1.5 1.5 0 0 0 8.5 10v4a1.5 1.5 0 0 0 1.5 1.5h4a1.5 1.5 0 0 0 1.5-1.5v-4A1.5 1.5 0 0 0 14 8.5h-4Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
